import { defineMessages } from 'react-intl'

const translations = defineMessages({
  myOrders: {
    defaultMessage: 'My Orders',
    id: 'global.account.order_history.link.order_history'
  },
  totalOrders: {
    defaultMessage: '{nbOrders} Orders',
    id: 'msp.account.order_history.total_orders'
  },
  placeholderHeading: {
    defaultMessage: `You haven't placed an order yet.`,
    id: 'msp.account.order_history.placeholder.no_order_yet'
  },
  placeholderText: {
    defaultMessage: 'Once you place an order, it will be visible here.',
    id: 'msp.account.order_history.placeholder.text'
  },
  placeholderCTAText: {
    defaultMessage: 'Continue Shopping',
    id: 'msp.account.order_history.placeholder.cta_text'
  },
  loadMore: {
    defaultMessage: `Load more orders`,
    id: 'msp.account.order_history.load_more'
  },
  noOrders: {
    defaultMessage: `You don't have any orders.`,
    id: 'msp.account.order_history.no_orders'
  }
})

export default translations
